export default "__VITE_ASSET__ybVZMcnQ__"